import { gql } from 'apollo-angular';

export const OFFER_SETTINGS_FRAGMENT = gql`
  fragment OfferSettingsFragment on OfferSettings {
    id
    prefix1 {
      ...OfferSettingsItemFragment
    }
    prefix2 {
      ...OfferSettingsItemFragment
    }
    prefix3 {
      ...OfferSettingsItemFragment
    }
    suffix {
      ...OfferSettingsItemFragment
    }
    minMargin
    fileExportStructureType
  }
  fragment OfferSettingsItemFragment on OfferSettingsItem{
    type
    value
    storedValue
  }
`;
